"use client";
import OurAchievement from "./our-achievement";

const About = () => {
    return (
        <section
            className={`desilo-about-area2 bg-color-white section-padding-top bg-color-2`}
        >
            <div className="container custom-container">
                <div className="row g-4 justify-content-between">
                    <div className="col-lg-4">
                        <h2 className="portfolio-details__title">
                            Our Story
                        </h2>
                    </div>
                    <div className="col-lg-6">
                        <div className="portfolio-details__content">
                            <p className="portfolio-text">
                                Desilo started with a simple realization: creators, startups, brands, and agencies all need digital spaces where authentic connections happen whether someone&apos;s discovering content, a team is launching something new, or a brand is scaling up. We build platforms that transform every moment of discovery into lasting engagement, giving every bold idea the foundation it needs to flourish.
                            </p>
                        </div>
                    </div>
                </div>
                <OurAchievement />
            </div>
        </section>
    );
};

export default About;
